import React, { useEffect, useState } from "react";
import { Heading } from "../catalyst/heading";
import { Text } from "../catalyst/text";
import Avatar from "../Avatar";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Button } from "../catalyst/button";
import { useConfirmationDialog } from "../ConfirmDialog";

interface InvitationRendererProps {
  invitations: any[];
  onAccept: (id: string) => void;
  onDecline: (id: string) => void;
}

export const InvitationRenderer: React.FC<InvitationRendererProps> = ({
  invitations,
  onAccept,
  onDecline,
}) => {
  const [myInvitations, setMyInvitations] = useState<any[]>([]);
  const { openDialog } = useConfirmationDialog();

  useEffect(() => {
    if (invitations && invitations.length > 0) {
      setMyInvitations(invitations.filter((i) => i.status === "pending"));
    } else {
      setMyInvitations([]);
    }
  }, [invitations]);

  const acceptClicked = (id: string) => {
    openDialog({
      title: "Accept Invitation",
      message:
        "Are you sure you want to accept this invitation? All other pending player/core member invitations will be rejected.",
      onConfirm: () => onAccept(id),
    });
  };

  const declineClicked = (id: string) => {
    openDialog({
      title: "Reject Invitation",
      message:
        "Are you sure you want to reject this invitation? This action cannot be undone.",
      onConfirm: () => onDecline(id),
    });
  };

  return (
    <div className="dark:bg-gray-800 dark:text-white  max-w-[800px] mx-auto shadow-lg rounded-lg">
      {myInvitations &&
        myInvitations.length > 0 &&
        myInvitations.map((invitation) => (
          <div
            key={invitation.id}
            className="bg-white dark:bg-gray-700 shadow-md rounded-lg p-4 mb-4 flex flex-col items-center text-center"
          >
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 flex-shrink-0">
                <Avatar
                  firstName={invitation.teamName}
                  lastName=""
                  imageUrl={`/api/static/images/${invitation.teamLogo}`}
                  className="h-11 w-11 rounded-full"
                />
              </div>
              <div className="leading-none flex flex-col">
                <div className="text-lg font-semibold text-gray-900 dark:text-gray-100 text-ellipsis w-full">
                  {invitation.teamName}
                </div>
              </div>
            </div>
            <Text>has invited you to join their team as</Text>

            <Heading level={6} className="mt-2">
              {invitation.role === "coreMember"
                ? "Core Member"
                : invitation.role === "teamOwner"
                ? "Team Owner"
                : "Player"}
            </Heading>
            <div className="flex space-x-4 w-full justify-end mt-5">
              <Button
                className={`px-4 bg-green-500 text-white rounded hover:bg-green-700`}
                color="green"
                onClick={() => acceptClicked(invitation.id)}
              >
                <CheckIcon className="h-5 w-5" />
                Accept
              </Button>
              <Button
                className={`px-4 bg-red-500 text-white rounded hover:bg-red-700`}
                color="red"
                onClick={() => declineClicked(invitation.id)}
              >
                <XMarkIcon className="h-5 w-5" />
                Reject
              </Button>
            </div>
          </div>
        ))}
    </div>
  );
};
